import cloneDeep from 'lodash/cloneDeep'
import { hashHistory } from 'react-router'

import {
  customerUpdate,
  reroute,
  storeDumpIt,
  storeDumpItCallBack,
  storeRestore,
  storeRestoreCallBack,
} from '../actions/Buy'
import { compassCalcolatriceLogistica } from '../actions/buy/Compass'
import { getOrdineAfterRestore } from '../actions/buy/Ordini'
import { postLastStepVisitedLead } from '../actions/common/Step'
import * as types from '../constants/ActionTypes'
import { findRoute, findRouteIndex } from '../constants/routes'

export const fetchMiddleware = () => next => action => {
  if (action) {
    next(action)
  }
}

export const rerouteMiddleware =
  ({ getState }) =>
  next =>
  action => {
    if (action.type === 'REROUTE') {
      const targetRoute = findRoute(action.payload)
      if (targetRoute.isExternal) {
        const state = getState()
        const targetUrl = new URL(
          `/${targetRoute.url}/${state.ordine.id_ordine}?token=${state.customer.token}`,
          window.location.origin
        ).toString()
        window.location.href = targetUrl
      } else {
        hashHistory.push(action.payload)
      }
    }
    next(action)
  }

export const loadStoreMiddleware =
  ({ getState, dispatch }) =>
  next =>
  action => {
    const nextt = next(action)

    if (action && action.type === types.STORE_RESTORE_INIT) {
      /**
       * recuperare da backend i dati, restorare e lanciare next
       */
      dispatch(
        storeRestore({
          method: 'GET',
          uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${action.payload.id_ordine}?frontend=1`,
          token: action.payload.id_token,
          callback: storeRestoreCallBack,
        })
      )
        .then(json => {
          // metto nuovo token
          dispatch(customerUpdate({ token: action.payload.id_token }))
          // chiamo i dettagli dell'ordine per rinfrescare eventuali
          // aggiornamenti nelle transazioni (stripe rifiutate)
          // o cambio prezzi
          getOrdineAfterRestore(
            dispatch,
            getState,
            action.payload.id_ordine
          ).then(() => {
            if (getState().payment.payment_method === 'finanziamento') {
              dispatch(compassCalcolatriceLogistica)
            }

            dispatch(reroute(json.result.frontend.rerouteTo))
          })

          /**
           * quando si fa restore
           * ed ho costi_extra ricalcolo le rate
           */
        })
        .catch(ex => {
          window.consolle.err('CATCH storeRestore', ex)
        })
    }

    /**
     * sempre fare next
     */
    return nextt
  }

export const dumpStoreMiddleware =
  ({ getState, dispatch }) =>
  next =>
  action => {
    /**
     * usando gli action type si decide quando
     * salvare lo store sul backend
     * di default non salva niente
     */
    let dumpIt = false
    let idOrdine = getState().ordine.id_ordine
    // dentro hash c'e' roba tipo #/cart?_k=oc9vih
    let rerouteTo = window.location.hash.split('?')[0].split('#')[1]
    const nextt = next(action)

    if (action) {
      switch (action.type) {
        // BRUM-13632 rimosso perche' imponeva che lo step dopo /cart fosse checkout ma ora abbiamo /servizi-aggiunitivi-usato
        // case types.NEW_ORDINE:
        //   // default behavior per questa action
        //   idOrdine = action.payload.data.result.id_ordine;
        //   rerouteTo = "/checkout";
        //   dumpIt = true;
        //   window.consolle.log(
        //     `dumpStoreMiddleware dump_it true per ${action.type}`,
        //     action
        //   );
        //   break;
        case types.STORE_DUMP_IT_FORCE:
          // se nella action arrivano override si applicano sempre
          idOrdine =
            action.payload && action.payload.id_ordine
              ? action.payload.id_ordine
              : idOrdine
          rerouteTo =
            action.payload && action.payload.rerouteTo
              ? action.payload.rerouteTo
              : rerouteTo
          dumpIt = true
          break
        default:
          break
      }
    }

    if (dumpIt) {
      if (!idOrdine) {
        window.consolle.omg(
          "dumpt_id true ma non c'e' id_ordine, non salvo checkpoint",
          action
        )
      } else {
        const state = getState()
        /**
         * il reroute deve essere sempre la rotta piu' lontanta in cui l'utente e' stato
         * */

        const prevIndex = findRouteIndex(state.rerouteTo)
        const nextIndex = findRouteIndex(rerouteTo)
        rerouteTo = nextIndex > prevIndex ? rerouteTo : state.rerouteTo
        dispatch({ type: 'SET_REROUTE', payload: rerouteTo })

        const lightState = cloneDeep(state)
        // BRUM-8851
        // quando fa questa clone
        // lo state non e' aggiornato
        // dal dispatch di cui sopra
        lightState.rerouteTo = rerouteTo
        /**
         * BRUM-5062
         * se dumpiamo lo stato di errore
         * potrebbe succedere che al recupero si veda un
         * errore vecchio
         */
        lightState.error = {
          display: false,
          payload: {
            status: null,
            url: null,
            text: null,
          },
        }

        lightState.comuni = {}
        lightState.compass_tabelledominio = {
          occupazioneattivita: {},
          settoreattivita: [],
          cittadinanza: [],
          cittadinanza_is_extra_eu_by_codice: {},
        }
        lightState.compassFileUpload = {
          dropzone: [],
          documenti_necessari: [],
        }
        lightState.bonificoFileUpload = {
          dropzone: [],
          documenti_necessari: [],
        }
        lightState.findomesticFileUpload = {
          dropzone: [],
          documenti_necessari: [],
        }

        lightState.secci.percorso_aws = null
        lightState.nlt.settore = []
        lightState.nlt.situazioneLavorativa = []
        lightState.nlt.occupazione = []
        lightState.nlt.tipoContratto = []
        lightState.nlt.statoCivile = []
        lightState.nlt.situazioneAbitativa = []
        lightState.nlt.caricaPrivata = []
        lightState.nlt.documenti_necessari = []
        lightState.nlt.dropzone = []

        // findomestic tabelle dominio
        lightState.findomestic.documenti_necessari = []
        lightState.findomestic.CodiciAbitazione = []
        lightState.findomestic.CodiciCarta = []
        lightState.findomestic.CodiciDestinatario = []
        lightState.findomestic.CodiciDocumento = []
        lightState.findomestic.CodiciNazionalita = []
        lightState.findomestic.CodiciPagamento = []
        lightState.findomestic.CodiciReperibilita = []
        lightState.findomestic.CodiciScadenza = []
        lightState.findomestic.CodiciStatoCivile = []
        lightState.findomestic.CodiciTipoAssicurazione = []
        lightState.findomestic.CodiciTipoDocumentoSoggiorno = []
        lightState.findomestic.CodiciTipoLavoro = []
        lightState.findomestic.CodiciTipoVeicolo = []
        lightState.findomestic.CodiciTitoloStudio = []
        lightState.findomestic.situazioneLavorativa = []
        lightState.findomestic.settoreBySituazione = []
        lightState.findomestic.occupazioneBySituazioneAndSettore = []
        lightState.findomestic.dati.pin = ''
        lightState.findomestic.dati.conferma_pin = ''
        lightState.findomestic.dati.otp = ''
        lightState.findomestic.dati.caps_lavoro = ''
        lightState.findomestic.dati.caps_precedente = ''
        lightState.findomestic.dati.documenti_necessari = []
        lightState.findomestic.servizi_assicurativi = []
        lightState.findomestic.MappaCodiciLavoroSettoriAttivita = []
        lightState.findomestic.CodiciSettoreAttivita = []
        lightState.findomestic.CodiciSettoreAttivitaById = []

        lightState.logistica.centri_convezionati = {}
        lightState.logistica.centri_convenzionati_by_provincia = {}

        lightState.uuid = lightState.uuid || window.brumbrum.uuid

        dispatch(
          storeDumpIt({
            method: 'PUT',
            uri: `${window.brumbrum.url_api}/ordini/t/v1/ordini/${idOrdine}`,
            token: lightState.customer.token,
            body: JSON.stringify({
              frontend: { ...lightState, rerouteTo },
              callback: storeDumpItCallBack,
            }),
          })
        )
          .then(() => {
            if (action.payload && action.payload.redirect_to) {
              window.location.href = action.payload.redirect_to
            }
          })
          .catch(ex => {
            window.consolle.err('CATCH storeDumpIt', ex)
          })

        dispatch(postLastStepVisitedLead)
      }
    }

    /**
     * sempre fare next!
     */
    return nextt
  }
